import { useEffect, useRef, useState } from 'react';
import * as THREE from 'three';
import { Text} from "@react-three/drei";
import { useFrame} from '@react-three/fiber';
import RoundedPlane from './RoundedPlane';

export default function TextInGroup(props) {
    const text = useRef(null);
    const [width, setWidth] = useState(0);
    const [opacity, setOpacity] = useState(0);
    const [ready, setReady] = useState(false);

    useEffect(()=>{
        text.current.material.opacity = 0;
        setOpacity(text.current.material.opacity);
        const checkSize = () =>{
            if(text.current){
                setWidth(text.current.geometry.boundingBox.max.x);
            }
        }
        for (let i = 0; i < 100; i++) {
            setTimeout(() =>{
                checkSize();
            },50)
        }
        setTimeout(() =>{
            setReady(true);
        },50)
    },[])

    useFrame(() => {
        if(!ready){
            text.current.material.opacity = 0;
        }
        else if(ready && props.isVisible){
            text.current.material.opacity = THREE.MathUtils.lerp(text.current.material.opacity, 1, 0.07 * 2.5);
        }
        else{
            text.current.material.opacity = THREE.MathUtils.lerp(text.current.material.opacity, 0, 0.07 * 2.5);
        }
        setOpacity(text.current.material.opacity);
    })

    return (
        <Text ref={text} font={'/fonts/PPNeueMontreal-Bold.otf'} fontSize={1.45} color={props.color} anchorX="start" position={[0.2,0,0.01]}>
            <RoundedPlane color={props.background} height={1.5 + 0.25} width={width + 0.2} opacity={opacity}/>
            {props.children}
        </Text>
    )
}